import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/crud_DOCUMENTOS';

const documentos = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title">Gestión Documentos</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default documentos;